import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { forwardRef, useRef } from "react";

const MapImageMarkerContent = ({
  id,
  coordinate,
  imageSource,
  onClick,
  isMyMarker,
  refCallback
}: {
  id: string;
  coordinate: google.maps.LatLng;
  imageSource: string;
  onClick: Function,
  isMyMarker: boolean,
  refCallback?: (marker: google.maps.marker.AdvancedMarkerElement | null, id: string) => void;
},
  ref: React.Ref<google.maps.marker.AdvancedMarkerElement>) => {
  const internalRef = useRef<google.maps.marker.AdvancedMarkerElement | null>(null);
  return <AdvancedMarker
    title={id}
    position={coordinate}
    zIndex={500}
    onClick={() => onClick(id)}
    ref={(marker) => {
      internalRef.current = marker;
      if (internalRef.current) {
        internalRef.current.dataset.isMyMarker = String(isMyMarker);
      }
      if (refCallback) refCallback(marker, id);
      if (typeof ref === 'function') ref(marker);
      else if (ref) (ref as React.MutableRefObject<google.maps.marker.AdvancedMarkerElement | null>).current = marker;
    }}
  >
    <img src={imageSource} width={24} height={24} style={{ display: 'block', zIndex: 500 }} />
  </AdvancedMarker>

}

export const MapImageMarker = forwardRef(MapImageMarkerContent);